<template>
  <v-card
    flat
    outlined
    :to="`/challenge/${challenge.name}#top`"
  >
    <v-card-title class="pb-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" :color="trophyColor" size="24" class="mt-1 mr-2">mdi-trophy</v-icon>
        </template>
        <span v-text="trophyText"></span>
      </v-tooltip>
      {{ challenge.name }}

      <v-spacer />

      <span class="text-body-1">
        <v-icon :color="submitColor" class="mb-1 mr-1" size="18">mdi-file-document</v-icon>
        <span class="mr-2">{{ submitCount }}</span>
        <v-icon :color="starColor" class="mb-1 mr-1" size="22">mdi-star</v-icon>
        <span class="mr-1">{{ starCount }}</span>
      </span>
    </v-card-title>

    <v-list three-line class="ml-8 pa-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            {{ challenge.description }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ challenge.expireAt.toDate().toISOString().substr(0, 10) }}
          </v-list-item-subtitle>

          <v-list-item-subtitle>
            <span
              v-for="tag in challenge.tags"
              :key="tag"
              color="primary"
            >
              #{{ tag }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-tooltip v-if="user" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-avatar v-bind="attrs" v-on="on" size="24">
              <img :src="user.photoURL" :alt="user.name">
            </v-list-item-avatar>
          </template>
          <span v-text="user.name"></span>
        </v-tooltip>
      </v-list-item>
    </v-list>
<!--
    <v-card-subtitle>
      <v-list-item class="ml-4">
        <v-list-item-content v-if="user">
          <v-list-item-title class="mb-2">
            {{ challenge.description }}
          </v-list-item-title>

          <v-list-item-subtitle>
            <span class="mr-2">
              {{ challenge.expireAt.toDate().toISOString().substr(0, 10) }}
            </span>

            <span
              v-for="tag in challenge.tags"
              :key="tag"
              color="primary"
            >
              #{{ tag }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar v-if="user" size="24">
          <img :src="user.photoURL" :alt="user.name">
        </v-list-item-avatar>
      </v-list-item>
    </v-card-subtitle>
-->
  </v-card>
</template>

<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"

export default {
  props: ['challenge'], 
  data: () => ({
    user: null,
  }),
  computed: {
    open: function () {
      const today = firebase.firestore.Timestamp.now()
      return this.challenge.expireAt >= today
    },
    starCount: function () {
      return this.challenge.stars ? this.challenge.stars.length : 0
    },
    starColor: function () {
      const stars = this.challenge.stars
      return this.$store.state.user.authenticated && stars && stars.includes(this.$store.state.user.uid) ?
        "yellow darken-3" : "grey"
    },
    submitCount: function () {
      return this.challenge != null && this.challenge.submitCount !== undefined ? this.challenge.submitCount : 0;
    },
    submitColor: function () {
      const submit = this.challenge.submitUsers
      return this.$store.state.user.authenticated && submit && submit.includes(this.$store.state.user.uid) ?
        "primary" : "grey"
    },
    trophyColor: function () {
      const open = this.challenge.expireAt >= firebase.firestore.Timestamp.now()
      return !this.challenge.publish ? "red" : open ? "yellow darken-4" : "primary"
    },
    trophyText: function () {
      const open = this.challenge.expireAt >= firebase.firestore.Timestamp.now()
      return !this.challenge.publish ? "非公開" : open ? "開催中" : "開催済み"
    },
  },
  watch: {
    challenge: function (val) {
      this.$bind("user", db.collection("users").doc(val.user))
    }
  },
  async created() {
    this.$bind("user", db.collection("users").doc(this.challenge.user))
  }
};
</script>



